<template>
    <div class="com-codics-book-admin-project-body">
        <div class="com-codics-book-admin-project-bar-content">
            <el-cascader class="com-codics-book-admin-project-bar-pick" :options="typeOptions" v-model="memsList"
                :show-all-levels="false" placeholder="请选择新闻类型"
                :props="{ value: 'id', label: 'value', children: 'data' }" clearable
                @change="handleMaterialTypeChange2"></el-cascader>
            <!-- <el-select class="com-codics-book-admin-project-bar-pick" v-model="nowSort" placeholder="请选择排序类型" clearable
                @change="listNewsFuc">
                <el-option v-for="item in sortOptions" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
            </el-select> -->
            <el-input class="com-codics-book-admin-project-bar-input" v-model="searchTxt" placeholder="输入关键词进行搜索..."
                clearable @input="searchChange" @change="handleSearchChange">
            </el-input>
            <MyButton style="float: left;margin-left: 15px;padding:0 15px;" @click.native="listNewsFuc">&#xe86e;
            </MyButton>
            <MyButton id="addNewBtn" style="float: right;" @click.native="addVisible = true;">&#xe632; 新建新闻
            </MyButton>
            <MyButton class="iconfonts" style="float: right;margin-right: 15px;" @click.native="handleCheckClick();"
                v-html="editState ? '&#xEB98; 取消编辑' : '&#xF597; 批量编辑'">
            </MyButton>
            <el-popconfirm confirm-button-text='好的' cancel-button-text='不用了' icon="el-icon-info" icon-color="red"
                title="您确定要删除选中的新闻吗？" @confirm="deleteNewsFuc">
                <MyButton v-show="editState" style="float: right;margin-right: 15px;" slot="reference">&#xe850; 批量删除
                </MyButton>
            </el-popconfirm>
            <MyButton v-show="editState" style="float: right;margin-right: 15px;" @click.native="checkAll">
                &#xEB79; 全部选中</MyButton>
        </div>
        <div class="com-codics-book-admin-project-bar-content com-codics-book-admin-project-bar-content2"
            style="margin-top: 10px;">
            <div class="com-codics-book-admin-project-list" :key="refreshKey"
                :style="{ '--opacity': (searchTxt ? searchData : tableData).length === 0 ? '1' : '0' }">
                <el-image class="com-codics-book-admin-project-bar-empty" @click="addVisible = true;"
                    v-show="(searchTxt ? searchData : tableData).length === 0"
                    :src="'https://cdn.bosscaigou.com/editor/img/%E6%9A%82%E6%97%A0%E5%86%85%E5%AE%B9%20%282%29.svg'"></el-image>
                <div v-show="(searchTxt ? searchData : tableData).length === 0" @click="addVisible = true;"
                    class="com-codics-book-admin-project-list-tip">还没有创建新闻，点此立即创建~</div>
                <div class="com-codics-book-admin-project-list-item"
                    v-for="(item, index) in (searchTxt ? searchData : tableData)" :key="item.id"
                    @click="handleItemClick(item)">
                    <div class="com-codics-book-admin-project-list-item-card"
                        :style="{ 'border': item.checked ? '1px solid #9333ea' : '1px solid #E5E5E5', '--opacity': item.checked ? '1' : '0' }">
                        <el-image class="com-codics-book-admin-project-list-item-card-img"
                            :src="item.himg.startsWith('http') ? item.himg : `https://cdn.bosscaigou.com/${item.himg}`"
                            fit="cover"></el-image>
                        <div class="com-codics-book-admin-project-list-item-state"
                            :style="{ 'background': item.state === 0 ? '#28a745' : '#f82828' }">{{ item.state === 0 ?
                                '正常' : '停用' }}
                        </div>
                        <div class="com-codics-book-admin-project-list-item-card-bottom" :key="refreshKey">
                            <span class="com-codics-book-admin-project-list-item-card-bottom-txt"
                                style="padding-left: 10px;">{{ item.title
                                }}</span>
                            <el-popover popper-class="com-codics-book-admin-project-list-item-card-bottom-btn-popover"
                                placement="top" width="160" trigger="hover">
                                <div class="com-codics-book-admin-project-list-item-card-bottom-btn-item"
                                    v-for="(item3, index3) in ['编辑', '删除']" :key="index3"
                                    @click="handleBtnClick(item, item3)">{{ item3 }}</div>
                                <div class="com-codics-book-admin-project-list-item-card-bottom-btn iconfonts"
                                    slot="reference" @click.stop="1">&#xe866;</div>
                            </el-popover>
                            <span
                                class="com-codics-book-admin-project-list-item-card-bottom-txt com-codics-book-admin-project-list-item-card-bottom-time">
                                {{ initTime(item.ctime) }}
                            </span>
                        </div>
                        <el-popconfirm title="确认要删除当前新闻吗？" trigger="hover" @confirm="deleteNewsFuc([item.id])">
                            <div class="com-codics-book-admin-project-list-item-card-delete iconfonts" title="删除"
                                @click.stop="1" slot="reference">&#xe850;
                            </div>
                        </el-popconfirm>
                    </div>
                </div>
            </div>
            <el-pagination class="codics-aonaer-info-sys-news-pagination" background @size-change="handleSizeChange"
                @current-change="handleCurrentChange" :current-page="searchTxt == '' ? currentPage : searchPage"
                :page-sizes="[15, 30, 45, 60]" :page-size="searchTxt == '' ? dataSize : searchSize"
                layout="total, sizes, prev, pager, next, jumper, slot" :total="searchTxt == '' ? maxSize : searchMax">
            </el-pagination>
        </div>
        <MyDialog :visible.sync="addVisible" title="新建新闻" :width="'1450px'" height="fit-content" :out="false">
            <MyForm style="margin-top: 10px;">
                <MyFormItem label="新闻类型" style="width: calc(50% - 7.5px);" required>
                    <el-cascader size="small" :options="typeOptions" v-model="memsList" :show-all-levels="false"
                        placeholder="请选择新闻分类" style="width:100%;"
                        :props="{ value: 'id', label: 'value', children: 'data' }" clearable
                        @change="handleMaterialTypeChange"></el-cascader>
                </MyFormItem>
                <MyFormItem label="新闻名称" style="width: calc(50% - 7.5px);margin-left:15px;height: 63.72px;" required>
                    <el-input v-model="addForm.title" style="width:100%;" autocomplete="off" maxlength="300" size="small"
                        show-word-limit></el-input>
                </MyFormItem>
                <MyFormItem label="新闻状态" style="width: calc(50% - 7.5px);" required>
                    <el-select v-model="addForm.state" placeholder="请选择新闻状态" style="width:100%;" size="small">
                        <el-option v-for="item in [{ value: 0, label: '正常' }, { value: 1, label: '停用' }]"
                            :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </MyFormItem>
                <MyFormItem label="新闻置顶" style="width: calc(50% - 7.5px);margin-left:15px;" required>
                    <el-select v-model="addForm.itop" placeholder="请选择是否置顶" style="width:100%;" size="small">
                        <el-option v-for="item in [{ value: 0, label: '否' }, { value: 1, label: '是' }]"
                            :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </MyFormItem>
                <MyFormItem label="产品权重" style="width: calc(50% - 7.5px);margin-left:15px;" required>
                    <el-input v-model="addForm.w1" style="width:100%;" type="number" autocomplete="off" maxlength="80"
                        size="small" show-word-limit></el-input>
                </MyFormItem>
                <MyFormItem label="发布时间" style="width: calc(50% - 7.5px);" required>
                    <el-date-picker v-model="addForm.ctime" type="datetime" placeholder="选择发布时间" style="width:100%;" size="small"></el-date-picker>
                </MyFormItem>
                <MyFormItem label="新闻介绍">
                    <el-input style="width:100%;" type="textarea" :rows="2" placeholder="请输入内容" size="small"
                        v-model="addForm.detail">
                    </el-input>
                </MyFormItem>
                <Toolbar style="border: 1px solid #ccc;width: 100%;margin-top: 25px;position: relative;float: left;"
                    :editor="editor" :defaultConfig="toolbarConfig" :mode="mode" />
                <Editor
                    style="height: calc(100% - 400px) !important;width: 100%;position: relative;float: left;border: 1px solid #ccc;border-top: none !important;"
                    v-model="addForm.content" :defaultConfig="editorConfig" :mode="mode" @onCreated="onCreated" />
                <MyFormItem label="素材标签">
                    <el-tag v-for="(tag, index) in addForm.tags" :key="index + 11" closable :disable-transitions="false"
                        style="margin-right: 15px;margin-left: unset !important;" @close="handleTagClose(tag)">
                        {{ tag.tag }}
                    </el-tag>
                    <el-input class="input-new-tag" v-show="inputTagVisible" v-model="inputTagValue" ref="saveTagInput"
                        type="textarea" style="width: 100% !important;" :autosize="{ minRows: 4, maxRows: 8 }"
                        size="small" @keyup.enter.native="handleInputConfirm" @blur="handleInputConfirm">
                    </el-input>
                    <el-button v-show="!inputTagVisible" class="button-new-tag" size="small" @click="showInput">+
                        新建标签</el-button>
                </MyFormItem>
                <MyFormItem label="新闻封面" style="width: calc(50% - 7.5px);height: fit-content;" required>
                    <MyUpload v-model="nowImg" :limit="1" size="100px"></MyUpload>
                </MyFormItem>
            </MyForm>
            <div style="height: 32px;width:100%;position:relative;float:left;margin-top:40px;margin-bottom:20px;">
                <el-button size="small" style="float:right;" type="success" plain @click="addNewFuc">确认创建</el-button>
                <el-button size="small" style="float:right;margin-right: 10px;" plain
                    @click="addVisible = false;">取消创建</el-button>
            </div>
        </MyDialog>
        <MyDialog :visible.sync="updateVisible" title="编辑新闻" :width="'1500px'" height="fit-content" :out="false"
            :close="closeUpdate">
            <MyForm style="margin-top: 10px;">
                <MyFormItem label="新闻类型" style="width: calc(50% - 7.5px);" required>
                    <el-cascader size="small" :options="typeOptions" v-model="updateType" :show-all-levels="false"
                        placeholder="请选择新闻分类" style="width:100%;"
                        :props="{ value: 'id', label: 'value', children: 'data' }" clearable
                        @change="handleMaterialTypeChange3"></el-cascader>
                </MyFormItem>
                <MyFormItem label="新闻名称" style="width: calc(50% - 7.5px);margin-left:15px;height: 63.72px;" required>
                    <el-input v-model="updateForm.title" style="width:100%;" autocomplete="off" maxlength="300"
                        size="small" show-word-limit></el-input>
                </MyFormItem>
                <MyFormItem label="新闻状态" style="width: calc(50% - 7.5px);" required>
                    <el-select v-model="updateForm.state" placeholder="请选择新闻状态" style="width:100%;" size="small">
                        <el-option v-for="item in [{ value: 0, label: '正常' }, { value: 1, label: '停用' }]"
                            :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </MyFormItem>
                <MyFormItem label="新闻置顶" style="width: calc(50% - 7.5px);margin-left:15px;" required>
                    <el-select v-model="updateForm.itop" placeholder="请选择是否置顶" style="width:100%;" size="small">
                        <el-option v-for="item in [{ value: 0, label: '否' }, { value: 1, label: '是' }]"
                            :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </MyFormItem>
                <MyFormItem label="产品权重" style="width: calc(50% - 7.5px);margin-left:15px;" required>
                    <el-input v-model="updateForm.w1" style="width:100%;" type="number" autocomplete="off"
                        maxlength="80" size="small" show-word-limit></el-input>
                </MyFormItem>
                <MyFormItem label="发布时间" style="width: calc(50% - 7.5px);" required>
                    <el-date-picker v-model="updateForm.ctime" type="datetime" placeholder="选择发布时间" style="width:100%;" size="small"></el-date-picker>
                </MyFormItem>
                <MyFormItem label="新闻介绍">
                    <el-input style="width:100%;" type="textarea" :rows="2" placeholder="请输入内容" size="small"
                        v-model="updateForm.detail">
                    </el-input>
                </MyFormItem>
                <Toolbar style="border: 1px solid #ccc;width: 100%;margin-top: 25px;position: relative;float: left;"
                    :editor="editor" :defaultConfig="toolbarConfig" :mode="mode" />
                <Editor
                    style="height: calc(100% - 400px) !important;width: 100%;position: relative;float: left;border: 1px solid #ccc;border-top: none !important;"
                    v-model="updateForm.content" :defaultConfig="editorConfig" :mode="mode" @onCreated="onCreated" />
                <MyFormItem label="素材标签">
                    <el-tag v-for="(tag, index) in updateForm.tags" :key="index + 11" closable
                        :disable-transitions="false" style="margin-right: 15px;margin-left: unset !important;"
                        @close="handleTagClose2(tag)">
                        {{ tag.tag }}
                    </el-tag>
                    <el-input class="input-new-tag" v-show="inputTagVisible" v-model="inputTagValue" ref="saveTagInput2"
                        style="width: 100% !important;" type="textarea" :autosize="{ minRows: 2, maxRows: 4 }"
                        size="small" @keyup.enter.native="handleInputConfirm2" @blur="handleInputConfirm2">
                    </el-input>
                    <el-button v-show="!inputTagVisible" class="button-new-tag" size="small" @click="showInput2">+
                        新建标签</el-button>
                </MyFormItem>
                <MyFormItem label="新闻封面" style="width: calc(50% - 7.5px);height: fit-content;" required>
                    <MyUpload v-model="nowImg" :limit="1" size="100px"></MyUpload>
                </MyFormItem>
            </MyForm>
            <div style="height: 32px;width:100%;position:relative;float:left;margin-top:40px;margin-bottom:20px;">
                <el-button size="small" style="float:right;" type="success" plain @click="updateNewFuc">确认修改</el-button>
                <el-button size="small" style="float:right;margin-right: 10px;" plain
                    @click="addVisible = false;">取消创建</el-button>
            </div>
        </MyDialog>
    </div>
</template>

<script>
import { Editor, Toolbar } from '@wangeditor/editor-for-vue';
import MyButton from '@/components/MyButton';
import MyDialog from '@/components/MyDialog';
import MyForm from '@/components/MyForm';
import MyUpload from '@/components/MyUpload';
import MyFormItem from '@/components/MyForm/MyFormItem';
// 引入随机字符串库
import { v4 as uuid } from 'uuid';
import { deleteUsers, repassUsers, listRole, userRole, listNews, addNew, deleteNews, updateNew, addTese, deleteTese, addCanshu, deleteCanshu, addInfo, deleteInfos } from '@/api';
import { formatTimeAgo, initTime, jumpTo, saveData } from '@/utils/myutils';
export default {
    data() {
        return {
            inputTagVisible4: false,
            inputTagValue41: '',
            inputTagValue42: '',
            nowImg2: [],
            editor: null,
            mode: 'default',
            toolbarConfig: {
                excludeKeys: ['fullScreen']
            },
            editorConfig: { placeholder: '请输入内容...' },
            inputTagValue2: '',
            teseVisible: false,
            shuxingVisible: false,
            updateVisible: false,
            nowVideo: [],
            inputTagVisible: false,
            inputTagValue: '',
            nowImg: [],
            nowImg2: [],
            isCheckAll: true,
            editState: false,
            refreshKey: 0,
            nowSize: null,
            addForm: {
                type: 0,
                title: '',
                detail: '',
                content: '',
                himg: '',
                state: 0,
                itop: 0,
                tag: '',
                w1: 0,
                ctime: null,
                tags: [],
                infos: []
            },
            updateForm: {
                id: null,
                type: 0,
                name: '',
                detail: '',
                himg: '',
                img: '',
                state: 0,
                tag: '',
                w1: 0,
                ctime: '',
                tags: [],
                video: ''
            },
            nowId: null,
            addVisible: false,
            tableData: [],
            searchData: [],
            selectData: [],
            roleData: [],
            memsList: [],
            searchTxt: '',
            nowSearchTxt: '',
            currentPage: 1,
            searchPage: 1,
            refreshKey2: 0,
            dataSize: 15,
            searchSize: 15,
            maxSize: 0,
            searchMax: 0,
            nowType: null,
            nowSort: null,
            updateType: [],
            teseTags: [],
            shuxingTags: [],
            shuxingTags2: [],
            teseForm: {
                pid: null,
                txt: ''
            },
            shuxingForm: {
                pid: null,
                name: '',
                content: ''
            }
        }
    },
    components: {
        MyButton,
        MyDialog,
        MyForm,
        MyFormItem,
        MyUpload,
        Editor,
        Toolbar
    },
    mounted() {
        this.listNewsFuc();
        Object.seal(this.editor)
    },
    beforeDestroy() {
        if (!this.editor) return;
        this.editor.destroy();
    },
    methods: {

        closeUpdate() {

            console.log(this.updateForm.info);

            if (this.searchTxt == '') {

                this.tableData.forEach(item => {
                    if (item.id == this.nowId) {
                        item.info = this.updateForm.info;
                    }
                });

            } else {

                this.searchData.forEach(item => {
                    if (item.id == this.nowId) {
                        item.info = this.updateForm.info;
                    }
                });

            }

            this.refreshKey++;

        },
        onCreated(editor) {
            this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
        },
        handleBtnClick(item, item3) {
            if (item3 == '编辑') {
                console.log(item);
                this.updateVisible = true;
                this.typeOptions.forEach(item4 => {
                    if (item4.id == item.type) {
                        this.updateType = [item4.id];
                    }
                });
                this.nowImg = [item.himg];
                this.nowImg2 = item.img == null || item.img == '' ? [] : item.img.split(',');
                this.updateForm = { ...item };
                this.updateForm.ctime = item.ctime ? new Date(item.ctime) : null;
                this.updateForm.tags = item.tag.split(',').map(item => ({ tag: item }));
            } else if (item3 == '删除') {
                this.deleteNewsFuc([item.id]);
            }
        },
        showInput() {
            this.inputTagVisible = true;
            this.$nextTick(() => {
                console.log(this.$refs.saveTagInput);
                this.$refs.saveTagInput.$refs.textarea.focus();
            });
        },
        handleTagClose(tag) {
            this.addForm.tags = this.addForm.tags.filter(item => item.tag != tag.tag);
            this.refreshKey++;
        },
        handleInputConfirm() {
            let inputTagValue = this.inputTagValue;
            this.addForm.tags = this.addForm.tags == null ? [] : this.addForm.tags;
            if (inputTagValue) {
                this.addForm.tags.push({
                    tag: inputTagValue
                });
            }
            this.inputTagVisible = false;
            this.inputTagValue = '';
        },
        showInput2() {
            this.inputTagVisible = true;
            this.$nextTick(() => {
                this.$refs.saveTagInput.$refs.input.focus();
            });
        },
        handleTagClose2(tag) {
            this.updateForm.tags = this.updateForm.tags.filter(item => item.tag != tag.tag);
            this.refreshKey++;
        },
        handleInputConfirm2() {
            let inputTagValue = this.inputTagValue;
            this.updateForm.tags = this.updateForm.tags == null ? [] : this.updateForm.tags;
            if (inputTagValue) {
                this.updateForm.tags.push({
                    tag: inputTagValue
                });
            }
            this.inputTagVisible = false;
            this.inputTagValue = '';
        },
        showInput3() {
            this.inputTagVisible3 = true;
            this.$nextTick(() => {
                this.$refs.saveTagInput.$refs.input.focus();
            });
        },
        handleTagClose3(index) {
            this.addForm.infos.splice(index, 1);
            this.refreshKey++;
        },
        async handleInputConfirm3() {
            let inputTagValue = this.inputTagValue31;
            let inputTagValue2 = this.inputTagValue32;
            this.addForm.infos = this.addForm.infos == null ? [] : this.addForm.infos;
            if (inputTagValue && inputTagValue2) {
                this.addForm.infos.push({
                    name: inputTagValue,
                    content: inputTagValue2
                });
            }
            this.inputTagVisible3 = false;
            this.inputTagValue31 = '';
            this.inputTagValue32 = '';
        },
        showInput4() {
            this.inputTagVisible4 = true;
            this.$nextTick(() => {
                this.$refs.saveTagInput4.$refs.textarea.focus();
            });
        },
        async handleTagClose4(tag, index) {
            const loading = this.$loading({
                lock: true,
                text: '加载中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            const data = await deleteInfos({
                ids: [tag.id]
            });
            loading.close();
            if (data.code == 200) {
                this.$message({
                    message: '删除成功！',
                    type: 'success'
                });
                this.updateForm.info = this.updateForm.info.filter(item => item.id != tag.id);
                this.refreshKey++;
            } else {
                this.$message({
                    message: data.message,
                    type: 'error'
                });
            }

        },
        async handleInputConfirm4() {
            let inputTagValue = this.inputTagValue41;
            let inputTagValue2 = this.inputTagValue42;
            if (inputTagValue && inputTagValue2) {
                const loading = this.$loading({
                    lock: true,
                    text: '加载中...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                const data = await addInfo({
                    cid: this.updateForm.id,
                    lb: inputTagValue,
                    vl: inputTagValue2
                });
                loading.close();
                if (data.code == 200) {
                    this.$message({
                        message: '添加成功！',
                        type: 'success'
                    });
                    this.updateForm.info.push(data.data);
                    this.inputTagValue41 = '';
                    this.inputTagValue42 = '';
                    this.inputTagVisible4 = false;
                } else {
                    this.$message({
                        message: data.message,
                        type: 'error'
                    });
                }
            }
        },
        checkAll() {
            var state = false;
            this.isCheckAll = !this.isCheckAll;
            if (this.isCheckAll) {
                this.tableData.forEach(item => {
                    item.checked = false;
                });
                this.searchData.forEach(item => {
                    item.checked = false;
                });
            } else {
                this.tableData.forEach(item => {
                    item.checked = true;
                });
                this.searchData.forEach(item => {
                    item.checked = true;
                });
            }
            this.refreshKey++;
        },
        handleItemClick(item) {
            if (this.editState) {
                console.log(item);
                item.checked = !item.checked;
                this.refreshKey++;
            } else {
                this.openProject(item);
            }
        },
        handleCheckClick() {
            this.editState = !this.editState;
            if (this.editState) {

            } else {
                this.tableData.forEach(item => {
                    item.checked = false;
                });
                this.searchData.forEach(item => {
                    item.checked = false;
                });
            }
            this.refreshKey++;
        },
        // 删除新闻
        async deleteNewsFuc(t) {

            if (t == null) {

                t = [];

                (this.searchTxt ? this.searchData : this.tableData).forEach(item => {

                    item.checked && (t[t.length] = item.id);

                });

                if (t.length == 0) {

                    this.$message({
                        showClose: true,
                        message: '请先选中要删除的数据！',
                        type: 'warning'
                    });

                    return true;

                }

            }

            const loading = this.$loading({
                lock: true,
                text: '正在删除新闻...',
                spinner: 'el-icon-loading',
            });

            const data = await deleteNews({ ids: t });

            loading.close();

            if (data.code == 200) {

                this.$message.success('删除成功');

                setTimeout(() => {

                    window.location.reload();

                }, 500);

            } else {

                this.$message.error(data.message);

            }
        },
        // 添加新闻
        async addNewFuc() {

            if (this.addForm.title == '') {
                this.$message.error('新闻名称不能为空');
                return;
            }

            if (this.addForm.type == '' || this.addForm.type == null) {
                this.$message.error('新闻类型不能为空!');
                return;
            }

            if (this.nowImg.length == 0) {
                this.$message.error('请上传新闻封面');
                return;
            }


            this.addForm.himg = this.nowImg[0];

            this.addForm.tag = (this.addForm.tags || []).map(item => item.tag).join(',');

            if (this.addForm.content == '') {
                this.$message.error('新闻内容不能为空');
                return;
            }

            const loading = this.$loading({
                lock: true,
                text: '正在添加新闻...',
                spinner: 'el-icon-loading',
            });

            const submitData = { ...this.addForm };
            if (submitData.ctime instanceof Date) {
                submitData.ctime = this.formatDateTime(submitData.ctime);
            }

            const data = await addNew(submitData);

            loading.close();

            if (data.code == 200) {

                this.$message.success('添加成功');

                setTimeout(() => {

                    window.location.reload();

                }, 500);

            } else {

                this.$message.error(data.message);

            }

            this.addVisible = false;

        },
        // 添加新闻
        async updateNewFuc() {

            if (this.updateForm.title == '') {
                this.$message.error('新闻名称不能为空');
                return;
            }

            if (this.updateForm.type == '' || this.updateForm.type == null) {
                this.$message.error('新闻类型不能为空!');
                return;
            }

            console.log(this.nowImg);

            if (this.nowImg.length == 0) {
                this.$message.error('请上传新闻封面');
                return;
            }

            this.updateForm.himg = this.nowImg[0];

            this.updateForm.tag = (this.updateForm.tags || []).map(item => item.tag).join(',');

            if (this.updateForm.content == '') {
                this.$message.error('新闻内容不能为空');
                return;
            }

            const loading = this.$loading({
                lock: true,
                text: '正在添加新闻...',
                spinner: 'el-icon-loading',
            });

            const submitData = { ...this.updateForm };
            if (submitData.ctime instanceof Date) {
                submitData.ctime = this.formatDateTime(submitData.ctime);
            }

            const data = await updateNew(submitData);

            loading.close();

            if (data.code == 200) {

                this.$message.success('编辑成功');

                setTimeout(() => {

                    window.location.reload();

                }, 500);

            } else {

                this.$message.error(data.message);

            }

            this.addVisible = false;

        },
        openProject(item) {
            saveData('projectId', item.pid);
            jumpTo(this, '页面', {}, {});
        },
        async listNewsFuc() {

            const loading = this.$loading({
                lock: true,
                text: '查询中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            const data = await listNews({
                key: this.nowSearchTxt,
                pge: this.searchTxt == '' ? this.currentPage : this.searchPage,
                psz: this.searchTxt == '' ? this.dataSize : this.searchSize,
                type: this.nowType || -1,
                sort: this.nowSort || 0
            });

            loading.close();

            if (data.code == 200) {

                if (this.searchTxt == '') {

                    this.typeOptions = data.type;

                    this.tableData = data.data;

                    this.maxSize = data.count;

                } else {

                    this.searchData = data.data;

                    this.searchMax = data.count;

                }

            } else {

                if (data.code == 401) return;

                this.$message.error(data.message);

            }

        },
        initTime(date) {
            return initTime(date);
        },
        formatDateTime(date) {
            if (!date) return '';
            // 转换为 ISO 8601 格式: yyyy-MM-ddTHH:mm:ss.SSSZ
            return date.toISOString();
        },
        async userRoleFuc() {
            if (this.nowId == null || this.nowId == '') {
                this.$message.error('请先选择要修改的用户！');
                return;
            }
            if (this.nowRole.length == 0) {
                this.$message.error('请选择用户角色！');
                return;
            }
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            let data = await userRole({
                id: this.nowId,
                role: this.nowRole[this.nowRole.length - 1]
            });
            loading.close();
            if (data.code == 200) {
                this.$message({
                    message: '修改成功！',
                    type: 'success'
                });
                setTimeout(() => {
                    window.location.reload();
                }, 300);
            } else {
                if (data.code == 401) return;

                this.$message.error(data.message);
            }
        },
        handleMaterialTypeChange(item) {
            this.addForm.type = item.length == 0 ? 0 : item[item.length - 1];
        },
        handleMaterialTypeChange2(item) {
            this.nowType = item.length == 0 ? 0 : item[item.length - 1];
            this.listNewsFuc();
        },
        handleMaterialTypeChange3(item) {
            this.updateForm.type = item.length == 0 ? 0 : item[item.length - 1];
        },
        roleChange() {

            if (this.nowSearchTxt == '') {

                this.currentPage = 1;

                this.dataSize = 10;

                this.tableData = [];

                this.listNewsFuc();

            } else {

                this.searchPage = 1;

                this.searchSize = 10;

                this.searchData = [];

                this.listNewsFuc();

            }

        },
        async listRoleFuc() {

            const data = await listRole();

            if (data.code == 200) {

                this.roleData = data.data;

            } else {

                if (data.code == 401) return;

                this.$message.error(data.message);

            }

        },
        addUserCommand(a) {
            switch (a) {
                case '直接创建':
                    this.registerDialog2 = true;
                    break;
                case '邀请注册':
                    this.registerDialog = true;
                    break;
            }
        },
        searchUsers() {

            if (this.searchTxt == '') {

                this.$message.error('请先输入要搜索的内容！');

                return;

            }

            this.searchPage = 1;

            this.searchMax = 0;

            this.searchData = [];

            this.nowSearchTxt = this.searchTxt;

            this.listNewsFuc();

        },
        async repassUsersFuc(t) {

            if (t == null) {

                if (this.selectData.length == 0) {

                    this.$message({
                        showClose: true,
                        message: '请先选中要重置的数据！',
                        type: 'warning'
                    });

                    return true;

                }

                var t = [];

                this.selectData.forEach(item => {

                    t[t.length] = item.id;

                });

            }

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            let data = await repassUsers({ ids: t });

            loading.close();

            if (data.code == 200) {

                this.$message({
                    message: '共' + data.count + '条数据重置成功！',
                    type: 'success'
                });

                setTimeout(() => {

                    window.location.reload();

                }, 300);

            } else {

                if (data.code == 401) return;

                this.$message.error(data.message);

            }

        },
        async deleteUsersFuc(t) {

            if (t == null) {

                if (this.selectData.length == 0) {

                    this.$message({
                        showClose: true,
                        message: '请先选中要删除的数据！',
                        type: 'warning'
                    });

                    return true;

                }

                var t = [];

                this.selectData.forEach(item => {

                    t[t.length] = item.id;

                });

            }

            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });

            let data = await deleteUsers({ ids: t });

            loading.close();

            if (data.code == 200) {

                this.$message({
                    message: data.count + '条数据删除成功！',
                    type: 'success'
                });

                setTimeout(() => {

                    window.location.reload();

                }, 300);

            } else {

                if (data.code == 401) return;

                this.$message.error(data.message);

            }

        },
        stateFilter(v, r, c) {

            return r.state === v;

        },
        memberFilter(v, r, c) {

            return r.member === v;

        },
        handleSizeChange(val) {
            if (this.searchTxt == '') {
                this.dataSize = val;
            } else {
                this.searchSize = val;
            }
            this.listNewsFuc();
        },
        handleSizeChange2(value) {
            const item = this.sizeOptions[value];
            this.addForm.width = item.width;
            this.addForm.height = item.height;
        },
        handleCurrentChange(val) {
            if (this.searchTxt == '') {
                this.currentPage = val;
            } else {
                this.searchPage = val;
            }
            this.listNewsFuc();
        },
        handleSelectionChange(val) {
            this.selectData = val;
        },
        searchChange(a) {
            if (a == '') {
                this.searchPage = 1;
                this.searchData = [];
                this.searchMax = 0;
                this.searchSize = 10;
                this.nowSearchTxt = '';
            }
        },
        handleSearchChange() {
            this.searchPage = 1;
            this.searchData = [];
            this.nowSearchTxt = this.searchTxt;
            this.listNewsFuc();
        }
    }
}
</script>

<style src="@wangeditor/editor/dist/css/style.css"></style>

<style>
.com-codics-book-admin-project-body {
    height: calc(100vh - 50px) !important;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    padding: 10px;
    overflow-y: auto;
}

:root {
    --el-input-bg-color: #FFF;
    --el-input-l-color: #DCDFE6;
    --el-input-l-hover-color: #C0C4CC;
    --el-input-l-focus-color: #000;
    --el-table-bg-color: #FFF;
    --el-table-l-color: #EBEEF5;
    --el-table-bg-hover-color: #F5F7FA;
    --el-table-body-font-color: #606266;
    --el-table-page-bg-color: #FFF;
    --el-table-page-bg-active-color: #333;
    --el-table-page-font-color: #606266;
    --el-table-page-font-active-color: #FFF;
}

:root[data-theme="dark"] {
    --el-input-bg-color: #333;
    --el-input-l-color: #444;
    --el-input-l-hover-color: #555;
    --el-input-l-focus-color: #888;
    --el-table-bg-color: #333;
    --el-table-l-color: #444;
    --el-table-bg-hover-color: #555;
    --el-table-body-font-color: #999;
    --el-table-page-bg-color: #292B2C;
    --el-table-page-bg-active-color: #FFF;
    --el-table-page-font-color: #AAA;
    --el-table-page-font-active-color: #333;
}

.el-input__inner {
    background-color: var(--el-input-bg-color) !important;
    border-color: var(--el-input-l-color) !important;
}

.el-input__inner:hover {
    border-color: var(--el-input-l-hover-color) !important;
}

.el-input__inner:focus {
    border-color: var(--el-input-l-focus-color) !important;
}

.el-table th.el-table__cell {
    background-color: var(--el-table-bg-color) !important;
}

.el-table tr {
    background-color: var(--el-table-bg-color) !important;
}

.el-table td.el-table__cell,
.el-table th.el-table__cell.is-leaf {
    border-bottom: 1px solid var(--el-table-l-color) !important;
}

.el-table--enable-row-hover .el-table__body tr:hover>td.el-table__cell {
    background-color: var(--el-table-bg-hover-color) !important;
}

.el-table--border::after,
.el-table--group::after,
.el-table::before {
    background-color: var(--el-table-l-color) !important;
}

.el-table {
    color: var(--el-table-body-font-color) !important;
}

.el-table,
.el-table__expanded-cell {
    background: var(--el-table-bg-color) !important;
}

.com-codics-book-admin-project-bar-content {
    height: fit-content;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    background: var(--sbar-bg-color);
    border-radius: 6px;
    border: 1px solid var(--sbar-l-3-color);
    padding: 15px;
    transition: .3s;
}

.com-codics-book-admin-project-bar-content2 {
    box-sizing: border-box;
    padding: 20px;
}

.com-codics-book-admin-project-bar-pick {
    position: relative;
    float: left;
    box-sizing: border-box;
    margin-right: 15px;
}

.com-codics-book-admin-project-bar-input {
    width: 220px !important;
    position: relative;
    float: left;
    box-sizing: border-box;
}

.codics-aonaer-info-sys-news-pagination {
    height: fit-content;
    position: relative;
    float: left;
    /* left: 50%; */
    margin-top: 20px;
    /* transform: translateX(-50%); */
}

.el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev,
.el-pagination.is-background .el-pager li {
    background-color: var(--el-table-page-bg-color) !important;
    color: var(--el-table-page-font-color) !important;
}

.el-pagination.is-background .el-pager .active {
    background-color: var(--el-table-page-bg-active-color) !important;
    color: var(--el-table-page-font-active-color) !important;
}

.com-codics-book-admin-project-list {
    height: fit-content;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
}

.com-codics-book-admin-project-list-item {
    height: 220px;
    width: 20%;
    position: relative;
    float: left;
    box-sizing: border-box;
    padding: 10px;
    cursor: pointer;
}

.com-codics-book-admin-project-list-item-card {
    height: 100%;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    background: #FFF;
    border-radius: 6px;
    /* border: 1px solid #E5E5E5; */
    transition: .3s;
}

.com-codics-book-admin-project-list-item-card-img {
    height: calc(100% - 40px);
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    border-radius: 0 0 6px 6px;
    border-bottom: 1px solid #E5E5E5;
    overflow: hidden;
    box-sizing: border-box;
}

.com-codics-book-admin-project-list-item-card-img img {
    user-select: none;
    -webkit-user-drag: none;
}

.com-codics-book-admin-project-list-item-card-bottom {
    height: 40px;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    line-height: 40px;
    font-size: 12px;
    color: #333;
}

.com-codics-book-admin-project-list-item-card-bottom-img {
    height: 100%;
    width: 40px;
    position: relative;
    float: left;
    box-sizing: border-box;
    padding: 9px !important;
}

.com-codics-book-admin-project-list-item-card-bottom-img img {
    border-radius: 50%;
    overflow: hidden;
}

.com-codics-book-admin-project-list-item-card-bottom-txt {
    position: relative;
    float: left;
    width: fit-content;
    max-width: calc(50% - 40px);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    box-sizing: border-box
}

.com-codics-book-admin-project-list-item-card-bottom-time {
    float: right !important;
    color: #999;
}

.com-codics-book-admin-project-list-item-card-bottom-btn {
    height: 100%;
    width: 40px;
    position: relative;
    float: right;
    box-sizing: border-box;
    line-height: 40px;
    font-size: 14px;
    color: #999;
    cursor: pointer;
    user-select: none;
    text-align: center;
    transition: .3s;
    -webkit-user-drag: none;
}

.com-codics-book-admin-project-list-item-card-delete {
    height: 26px;
    width: 26px;
    position: absolute;
    margin: auto;
    top: 10px;
    right: 10px;
    box-sizing: border-box;
    background: #f82828;
    border-radius: 4px;
    color: #FFF;
    cursor: pointer;
    user-select: none;
    text-align: center;
    line-height: 26px;
    font-size: 10px;
    opacity: 0;
    transition: .3s;
    -webkit-user-drag: none;
}

.com-codics-book-admin-project-list-item-card:hover .com-codics-book-admin-project-list-item-card-delete {
    opacity: .5;
}

.com-codics-book-admin-project-list-item-card-delete:hover {
    opacity: 1 !important;
}

.com-codics-book-admin-project-list-item-card-delete:active {
    opacity: .9 !important;
}

@media screen and (max-width: 1400px) {
    .com-codics-book-admin-project-list-item {
        width: 33.33333%;
    }
}

@media screen and (max-width: 756px) {
    .com-codics-book-admin-project-list-item {
        width: 50%;
    }
}

@media screen and (max-width: 556px) {
    .com-codics-book-admin-project-list-item {
        width: 100%;
    }
}

.com-codics-book-admin-project-list-tip {
    height: 40px;
    width: fit-content;
    position: absolute;
    margin: auto;
    top: 180px;
    bottom: 0;
    left: 0;
    right: 0;
    box-sizing: border-box;
    font-size: 13px;
    color: #999;
    text-align: center;
    line-height: 40px;
    opacity: var(--opacity);
    transition: .3s;
    cursor: pointer;
    user-select: none;
    -webkit-user-drag: none;
}

.com-codics-book-admin-project-list-item-card-bottom-btn-popover {
    padding: unset !important;
    border-radius: 5px !important;
}

.com-codics-book-admin-project-list-item-card-bottom-btn-item {
    height: 33px;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
    line-height: 33px;
    font-size: 12px;
    color: #333;
    cursor: pointer;
    user-select: none;
    text-align: center;
    transition: .3s;
    -webkit-user-drag: none;
    font-family: 'pingfang-regular';
}

.com-codics-book-admin-project-list-item-card-bottom-btn-item:hover {
    background: #EEE;
}

.input-new-tag {
    width: 90px !important;
    margin-right: 10px;
    vertical-align: bottom;
}

.el-tag {
    transition: none !important;
}
</style>